/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { LocationsBaseComponent } from '../../components/LocationsBaseComponent/LocationsBaseComponent';

export function StoreDetailsPage() {
  return <LocationsBaseComponent pageType="STORE_DETAILS" />;
}
